import type { ShowConsultation } from '@/components/PatientPageV2/components/ConsultationTabSections/ShowConsultation';
import type { Consultation } from '@/hooks/patients/usePatientConsultations';
import { useAppStore } from '@/state-management/store';
import type { ConsultationModel } from '@/types';
import { useMemo } from 'react';
import { useShallow } from 'zustand/react/shallow';

/**
 * Shared hook for accessing consultation store data
 * @param consultation
 */
export const useConsultationStore = (
  consultation: Consultation | ShowConsultation | ConsultationModel | null | undefined,
) => {
  const consultationId = useMemo(() => consultation?.id, [consultation?.id]);

  const consultationFields = useAppStore(
    useShallow((state) => (consultationId ? state.getConsultationFields(consultationId) : undefined)),
  );

  const setConsultationField = useAppStore((state) => state.setConsultationField);

  return {
    // Store values
    paymentRequestType: consultationFields?.paymentRequestType,
    isMarkedAsComplimentary: consultationFields?.isMarkedAsComplimentary,

    // Actions
    setConsultationField,

    // Metadata
    consultationId,
    hasConsultation: !!consultationId,
  };
};
